"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Lock = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "2 3 12 11",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.667 3.833H7.333C6.597 3.833 6 4.43 6 5.167V6.5h4V5.167c0-.737-.597-1.334-1.333-1.334zm-4 2.667V5.167A2.667 2.667 0 017.333 2.5h1.334a2.667 2.667 0 012.666 2.667V6.5a2 2 0 012 2v4a2 2 0 01-2 2H4.667a2 2 0 01-2-2v-4a2 2 0 012-2zm4.666 3.333c0 .494-.268.925-.666 1.155v.845a.667.667 0 11-1.334 0v-.845a1.333 1.333 0 112-1.155z",
  fill: "#ACB3BE"
}));
var _default = exports.default = Lock;